import { AiTwotoneShop } from "react-icons/ai";
import { FaBookOpen, FaRegNewspaper } from "react-icons/fa";
import { FiPackage } from "react-icons/fi";
import { GiVerticalBanner } from "react-icons/gi";
import { GrGallery } from "react-icons/gr";
import { LuCircleDollarSign } from "react-icons/lu";
import { MdBedroomParent, MdOutlineEvent } from "react-icons/md";
import { RiGalleryLine, RiReservedFill, RiSpeakFill } from "react-icons/ri";
export const ROOTS_DASHBOARD = "/admin";

export const PATH_AUTH = {
  login: "/login",
  privacy: "/privacy-policy",
};

function path(root, sublink) {
  return `${root}${sublink}`;
}

export const PATH_DASHBOARD = path(ROOTS_DASHBOARD, "/overview");

const menu = [
  {
    title: "Banner",
    icon: <GiVerticalBanner size={35} />,
    path: path(ROOTS_DASHBOARD, "/banner"),
  },
  {
    title: "Event",
    icon: <MdOutlineEvent size={35} color="#ddd" />,
    path: path(ROOTS_DASHBOARD, "/events"),
  },
  {
    title: "Event Gallery",
    icon: <GrGallery size={35} color="#ddd" />,
    path: path(ROOTS_DASHBOARD, "/event-gallery"),
  },
  {
    title: "Menu Gallery",
    icon: <RiGalleryLine size={35} color="#ddd" />,
    path: path(ROOTS_DASHBOARD, "/menu"),
  },
  {
    title: "Testimonial",
    icon: <RiSpeakFill size={35} color="#ddd" />,
    path: path(ROOTS_DASHBOARD, "/testimonial"),
  },

  // Add PAths

  {
    title: "Service",
    icon: <AiTwotoneShop size={35} color="#ddd" />,
    path: path(ROOTS_DASHBOARD, "/services"),
  },
  {
    title: "Booking",
    icon: <RiReservedFill size={35} color="#ddd" />,
    path: path(ROOTS_DASHBOARD, "/bookings"),
  },
  {
    title: "News",
    icon: <FaRegNewspaper size={35} color="#ddd" />,
    path: path(ROOTS_DASHBOARD, "/news"),
  },

  {
    title: "Room Type",
    icon: <MdBedroomParent size={35} color="#ddd" />,
    path: path(ROOTS_DASHBOARD, "/room-types"),
  },

  {
    title: "Package",
    icon: <FiPackage size={35} color="#ddd" />,
    path: path(ROOTS_DASHBOARD, "/packages"),
  },

  {
    title: "Room Rate",
    icon: <LuCircleDollarSign size={35} color="#ddd" />,
    path: path(ROOTS_DASHBOARD, "/room-rates"),
  },

  {
    title: "Rooms Booking",
    icon: <FaBookOpen size={35} color="#ddd" />,
    path: path(ROOTS_DASHBOARD, "/room-booking"),
  },
];

export default menu;
